/* eslint-disable no-underscore-dangle */
import { EditorState, LexicalNode } from 'lexical';

export const hasNodeType = (
  editorState: EditorState,
  nodeType: string,
  checkCallback?: (node: LexicalNode | null | undefined) => boolean,
): boolean => {
  return editorState.read(() => {
    const nodesList = Array.from(editorState._nodeMap.values()).filter(
      ({ __type }) => __type === nodeType,
    );

    if (checkCallback) {
      return nodesList.some((node) => checkCallback(node));
    }

    return !!nodesList.length;
  });
};
